import React from "react";

const StartPageLayout = (props) => {
  return <div className="layout-container">{props.children}</div>;
};

export default StartPageLayout;
